import { render, staticRenderFns } from "./popPage.vue?vue&type=template&id=2565b100&"
import script from "./popPage.vue?vue&type=script&lang=js&"
export * from "./popPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports